const toRem = (px: number) => `${px / 16}rem`;

export const fonts = {
  primary: "'Poppins', sans-serif",
  secondary: "'Overpass', sans-serif",
  systemUI: "system-ui"
} as const;

export const textStyles = {
  heading: {
    h1: {
      fontSize: toRem(48),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(58)
    },
    h2: {
      fontSize: toRem(36),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(46)
    },
    h3: {
      fontSize: toRem(30),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(42)
    },
    h4: {
      fontSize: toRem(28),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(34)
    },
    h5: {
      fontSize: toRem(22),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(28)
    },
    h6: {
      fontSize: toRem(18),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(24)
    }
  },
  caption: {
    caption1: {
      fontSize: toRem(28),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(40)
    },
    caption2: {
      fontSize: toRem(24),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(36)
    },
    caption3: {
      fontSize: toRem(22),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(30)
    },
    caption4: {
      fontSize: toRem(18),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(26)
    },
    caption5: {
      fontSize: toRem(16),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(24)
    },
    caption6: {
      fontSize: toRem(14),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(20)
    },
    caption7: {
      fontSize: toRem(12),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(16)
    },
    caption8: {
      fontSize: toRem(10),
      fontFamily: fonts.primary,
      fontWeight: 700,
      lineHeight: toRem(14)
    }
  },
  body: {
    body1Regular: {
      fontSize: toRem(20),
      fontFamily: fonts.secondary,
      fontWeight: 400,
      lineHeight: toRem(30)
    },
    body1Medium: {
      fontSize: toRem(20),
      fontFamily: fonts.secondary,
      fontWeight: 500,
      lineHeight: toRem(30)
    },
    body1SemiBold: {
      fontSize: toRem(20),
      fontFamily: fonts.secondary,
      fontWeight: 600,
      lineHeight: toRem(30)
    },
    body1Bold: {
      fontSize: toRem(20),
      fontFamily: fonts.secondary,
      fontWeight: 700,
      lineHeight: toRem(30)
    },
    body2Regular: {
      fontSize: toRem(18),
      fontFamily: fonts.secondary,
      fontWeight: 400,
      lineHeight: toRem(26)
    },
    body2Medium: {
      fontSize: toRem(18),
      fontFamily: fonts.secondary,
      fontWeight: 500,
      lineHeight: toRem(26)
    },
    body2SemiBold: {
      fontSize: toRem(18),
      fontFamily: fonts.secondary,
      fontWeight: 600,
      lineHeight: toRem(26)
    },
    body2Bold: {
      fontSize: toRem(18),
      fontFamily: fonts.secondary,
      fontWeight: 700,
      lineHeight: toRem(26)
    },
    body3Regular: {
      fontSize: toRem(16),
      fontFamily: fonts.secondary,
      fontWeight: 400,
      lineHeight: toRem(24)
    },
    body3Medium: {
      fontSize: toRem(16),
      fontFamily: fonts.secondary,
      fontWeight: 500,
      lineHeight: toRem(24)
    },
    body3SemiBold: {
      fontSize: toRem(16),
      fontFamily: fonts.secondary,
      fontWeight: 600,
      lineHeight: toRem(24)
    },
    body3Bold: {
      fontSize: toRem(16),
      fontFamily: fonts.secondary,
      fontWeight: 700,
      lineHeight: toRem(24)
    },
    body4Regular: {
      fontSize: toRem(14),
      fontFamily: fonts.secondary,
      fontWeight: 400,
      lineHeight: toRem(20)
    },
    body4Medium: {
      fontSize: toRem(14),
      fontFamily: fonts.secondary,
      fontWeight: 500,
      lineHeight: toRem(20)
    },
    body4SemiBold: {
      fontSize: toRem(14),
      fontFamily: fonts.secondary,
      fontWeight: 600,
      lineHeight: toRem(20)
    },
    body4Bold: {
      fontSize: toRem(14),
      fontFamily: fonts.secondary,
      fontWeight: 700,
      lineHeight: toRem(20)
    },
    body5Regular: {
      fontSize: toRem(12),
      fontFamily: fonts.secondary,
      fontWeight: 400,
      lineHeight: toRem(16)
    },
    body5Medium: {
      fontSize: toRem(12),
      fontFamily: fonts.secondary,
      fontWeight: 500,
      lineHeight: toRem(16)
    },
    body5SemiBold: {
      fontSize: toRem(12),
      fontFamily: fonts.secondary,
      fontWeight: 600,
      lineHeight: toRem(16)
    },
    body5Bold: {
      fontSize: toRem(12),
      fontFamily: fonts.secondary,
      fontWeight: 700,
      lineHeight: toRem(16)
    },
    body6Regular: {
      fontSize: toRem(10),
      fontFamily: fonts.secondary,
      fontWeight: 400,
      lineHeight: toRem(14)
    },
    body6Medium: {
      fontSize: toRem(10),
      fontFamily: fonts.secondary,
      fontWeight: 500,
      lineHeight: toRem(14)
    },
    body6SemiBold: {
      fontSize: toRem(10),
      fontFamily: fonts.secondary,
      fontWeight: 600,
      lineHeight: toRem(14)
    },
    body6Bold: {
      fontSize: toRem(10),
      fontFamily: fonts.secondary,
      fontWeight: 700,
      lineHeight: toRem(14)
    }
  }
} as const;

export const toCSS = (style: {
  fontSize: string;
  fontFamily: string;
  fontWeight: number;
  lineHeight: string;
}) => `
  font-size: ${style.fontSize};
  font-family: ${style.fontFamily};
  font-weight: ${style.fontWeight};
  line-height: ${style.lineHeight};
`;

export type Fonts = typeof fonts;
export type TextStyles = typeof textStyles;
